/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import TimeZoneService from "./Services/TimeZoneService";

require('./bootstrap');

import { createInertiaApp } from "@inertiajs/vue2";
import Vue from 'vue'
import VueMeta from 'vue-meta'
import PortalVue  from 'portal-vue'
import moment from 'moment';
import tz from 'moment-timezone';
import AuctionState from "./mixins/AuctionState";
import VueI18n from 'vue-i18n'
import loadLocaleMessages from "./loadLocaleMessages";
import loadNumberFormats from "./loadNumberFormats";

const messages = loadLocaleMessages();
const numberFormats = loadNumberFormats();

window.Vue = Vue;

Vue.config.productionTip = false;
Vue.mixin({ methods: { route: window.route } });
Vue.use(VueMeta);
Vue.use(PortalVue);
Vue.use(VueI18n);

// Mixins
Vue.use(AuctionState);

Vue.prototype.$route = (...args) => route(...args);

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format(window.i18n.t('locale.formatDate'));
    }
});

Vue.filter('formatTime', function(value, timeFormat, timezone, timeCode ) {
    if (value) {
        let t = moment.tz(String(value), timezone);
        let retVal = t.format( timeFormat ? timeFormat : window.i18n.t('locale.formatTime'));
        return retVal + (timeCode ? ' ' + timeCode : '');
    }
});

/**
 * Format only the AM/PM of the time depending on the given time value and return only AM/PM
 */
Vue.filter('formatTimeAmPm', function(value, timezone) {
    if (value) {
        return Vue.options.filters.formatTime(value, 'A', timezone, TimeZoneService.code());
    }
});

/**
 * Format only the AM/PM of the time depending on the given time value and return only AM/PM
 */
Vue.filter('formatDateAndTimeAmPm', function(value) {
    if (value) {
        return moment(String(value)).format(window.i18n.t('locale.formatDayDateAndTime'));
    }
});

Vue.filter('formatDay', function(value) {
    if (value) {
        return moment(String(value)).format(window.i18n.t('locale.formatDay'));
    }
});

Vue.filter('toCurrency', function (value, digits) {
    if (typeof value !== "number" && isNaN(parseFloat(value))) {
        return value;
    }
    value = parseFloat(value);
    var formatter = new Intl.NumberFormat(window.i18n.locale ?? 'en-us', {
        style: 'currency',
        currency: window.i18n.numberFormats[window.i18n.locale]?.currency?.currency ?? 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: digits || 0
    });
    return formatter.format(value);
});

Vue.filter('toNumber', function (value, minimumFractionDigits = 2, maximumFractionDigits = 2) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat(window.i18n.locale ?? 'en-us', {
        minimumFractionDigits: minimumFractionDigits,
        maximumFractionDigits: maximumFractionDigits
    });
    return formatter.format(value);
});

const app = document.getElementById('app');
const page = JSON.parse(app.dataset.page);

window.page = page;
window.i18n = new VueI18n({
    locale: page?.props?.global?.locale ||'en', // set locale
    fallbackLocale: 'en', // set fallback locale
    numberFormats,
    messages
});

createInertiaApp({
    progress: {
        showSpinner: true,
        delay: 100,
        color: '#374151'
    },
    resolve: name => require(`./Pages/${name}`),
    setup({ el, App, props, plugin }) {
        Vue.use(plugin)

        new Vue({
            metaInfo: {
                titleTemplate: (title) => title ? `AWA - ${title} - ${page.props.tenant.misc.name}` : page.props.tenant.misc.name
            },
            i18n: window.i18n,
            render: h => h(App, props),
        }).$mount(el)
    },
})
